import Link from "next/link"
import { useLayoutData } from "../../../../../../utils/contexts/LayoutContext"

const TopBar = () => {
  const { partnerSiteFull } = useLayoutData()

  return (
    <>
      <div className="header-top-bar">
        <div className="container-fluid px-2 px-md-5">
          <div className="row align-items-center">
              <div className="col-lg-12">
                <div className="top-bar-left-wrapper py-2">
                  <div className="social-links social-links--white-topbar d-inline-block">
                    <ul>
                      {partnerSiteFull?.content?.topBar?.items?.map((item, i) => {
                        if (item.rightSide) {
                          return (
                            <li key={i}>
                              <Link href={item.link ?? "/"}>
                                <a target="_blank">
                                  <i className={`fa ${item.ikon}`} />
                                </a>
                              </Link>
                            </li>
                          )
                        }
                      })}
                    </ul>
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default TopBar